import React from "react";
import { getAllStocksData } from "../../services/TradingMallService";
import TopCategoriesClient from "./TopCategoriesClient";
import {
  textEllipsis,
  TITLE_CHAR_LIMIT,
  MARKET_CAP_FILTERS,
  DEFAULT_MARKET_CAP,
} from "./clpCardConstant";
import { ComponentContent, StockTab } from "../../types/stocks";

interface TopCategoriesProps {
  content?: ComponentContent;
}

export const TopCategories: React.FC<TopCategoriesProps> = async ({
  content,
}) => {
  const [topgainers, toplosers, weekshigh, weekslow] = await Promise.all([
    getAllStocksData({ exchId: "0", entity: "topgainers", mktcap: [DEFAULT_MARKET_CAP] }),
    getAllStocksData({ exchId: "0", entity: "toplosers", mktcap: [DEFAULT_MARKET_CAP] }),
    getAllStocksData({ exchId: "0", entity: "52weekhigh", mktcap: [DEFAULT_MARKET_CAP] }),
    getAllStocksData({ exchId: "0", entity: "52weeklow", mktcap: [DEFAULT_MARKET_CAP] }),
  ]);

  const stocksData = { topgainers, toplosers, weekshigh, weekslow };

  return (
    <section >
      <TopCategoriesClient
        stocksData={stocksData}
        defaultImage={content?.defaultImageLink}
        tabs={Object.values(content?.tabs?.[0] || {}) as StockTab[]}
        viewAllLabel={content?.label || "View all"}
        stockNotFoundText={content?.stockNotFoundText || "No stocks found."}
        stockNotFoundImgUrl={content?.stockNotFoundImgUrl || ""}
        modalTitle={content?.modalTitle}
        modalBtnCta={content?.modalBtnCta}
        successMsg={content?.successMsg}
        errorMsg={content?.errorMsg}
        title={textEllipsis(
          content?.componentTitle || "Top Categories",
          TITLE_CHAR_LIMIT,
        )}
        marketCapFilters={MARKET_CAP_FILTERS}
        defaultMarketCap={DEFAULT_MARKET_CAP}
      />
    </section>
  );
};
